import React from 'react';
import { AccordionDetails, Grid, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { PassOut } from '../../../../api';
import { Accordion, AccordionSummary } from '../../../../calendar/dialogs/EditOrderDialog/components/Accordion';
import { EditPassFormValues, PassDetailPanels } from '../../PassDetailTypes';

type Props = {
  pass: PassOut;
  expandedPanel: PassDetailPanels | undefined;
  onPanelChange: (panel: PassDetailPanels) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
};

export const PersonalDetailsPanel = ({ pass, expandedPanel, onPanelChange }: Props) => {
  const { t } = useTranslation();
  const { values, errors, touched, handleChange } = useFormikContext<EditPassFormValues>();

  return (
    <Accordion
      expandedPanelName={expandedPanel}
      panelName={PassDetailPanels.PersonalDetails}
      onChange={onPanelChange}
      allOpenValue={PassDetailPanels.AllOpen}>
      <AccordionSummary
        title={t('passes.customer_details')}
        summaryComponent={
          <Typography variant="body2" color="text.secondary">
            {pass.email}
          </Typography>
        }
      />
      <AccordionDetails>
        {/* Using plain TextField instead of FormTextField so Chrome offers autofill suggestions */}
        <Grid container flexDirection="column" gap={1} xs={12}>
          <TextField
            fullWidth
            id="firstname"
            name="firstname"
            label={t('passes.firstname')}
            value={values.firstname}
            onChange={handleChange}
            error={touched.firstname && Boolean(errors.firstname)}
            helperText={touched.firstname && errors.firstname}
          />
          <TextField
            fullWidth
            id="lastname"
            name="lastname"
            label={t('passes.lastname')}
            value={values.lastname}
            onChange={handleChange}
            error={touched.lastname && Boolean(errors.lastname)}
            helperText={touched.lastname && errors.lastname}
          />
          <TextField
            fullWidth
            id="alternative_full_name"
            name="alternative_full_name"
            label={t('order_page.alternative_full_name')}
            value={values.alternative_full_name}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            id="email"
            name="email"
            label={t('passes.email_field')}
            value={values.email}
            onChange={handleChange}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
          <TextField
            fullWidth
            id="phone"
            name="phone"
            label={t('passes.phone')}
            value={values.phone}
            onChange={handleChange}
            error={touched.phone && Boolean(errors.phone)}
            helperText={touched.phone && errors.phone}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
